import store from "../store";
import moment from "moment";
import { merge } from "lodash";
import PGSHelper from "../helpers/PGSHelper.js";
import Currencies from "./Currencies.js";
export default class Reserva {
  static $pgsHelper = new PGSHelper();
  constructor(type) {
    this.Tipo = type;
  }

  static rules = {
    Nombre: [(value) => !!value || "El nombre es obligatorio"],
    Tarifa: [(value) => !!value || "La tarifa es obligatoria"],
  };

  static getRules() {
    return this.rules;
  }

  static async getById(id) {
    const firestore = store.getters.getFirebaseApp.firestore;
    const doc = firestore.doc("RVA_Reservas", id);
    const data = await firestore.getDoc(doc);
    let dataReserva = { id: data.ref.id, ...data.data() };
    return dataReserva;
  }

  static buildRVAData(data) {
    let dataRVA = {
      UpdatedAt: data.UpdatedAt,
      Cliente: {
        Nombre: data.Cliente.name,
        Correo: data.Cliente.email,
        Telefono: data.Cliente.phone,
        IdCliente: data.Cliente.isClient ? data.Cliente.IdCliente : null,
      },
      Bahia: data.Bahia || 1,
      Estatus: "Confirmed",
      RF: {
        FI: data.FechaInicial, // Fecha Inicio
      },
      TTP: data.TTP ? Number(data.TTP) : undefined,
      Privado: data.Privado,
      Totales: {
        USD: parseFloat(data.Total.total),
        MXN: parseFloat(data.Total.totalPesos),
      },
      Creador: data.Creador,
      Prepagado: data.Prepagado,
      Notas: data.Notas,
      Departamento: data.Departamento,
      Tags: data.Tags,
      Mayorista: data.Mayorista,
      Concierge: data.Concierge,
      Transportacion: data.Transportacion,
      Cuentas: {},
    };

    if (data.FechaFinal) {
      dataRVA.RF.FT = data.FechaFinal;
    }

    if (data.Invitados) {
      dataRVA.Invitados = data.Invitados;
    }
    //armado de la data de cuentas
    let pgsHelper = new PGSHelper()
    data.Players.forEach((player, index) => {
      let catalogo = [];
      //producto Tarifa
      if (player.useRondaCupon) {
        let cuponData = pgsHelper.getById(player.dataCupones, "CCI", player.CCI)
        catalogo.push({
          Id: cuponData?.Codigo,
          Tip: "Serie",
          Orn: data.Departamento,
          Nombre: cuponData?.Nombre,
          Pco: cuponData?.Precio,
          Cnt: 1,
          Mnd: cuponData?.Moneda,
          ExtraParams: {
            TarifaData: {
              CCI: player.CCI,
              Mod: data.Modalidad.id,
            },
          },
        });
      } else {
        /*if (data.Tipo != "Golf") {
          if (data.TTProduct) {
            catalogo.push({
              Id: player.TarifaSelected.TarifaId,
              Orn: data.Departamento,
              Tip: "Reserva",
              Cnt: 1,
              Pco: parseFloat(data.Total.total).toFixed(2),
              Nombre: "Top Tracer web ",
              Mnd: "USD",
              ExtraParams: {
                TimesData: data.TimesData,
                TTEData: data.TTEData,
              },
              Departamento: data.Departamento,
            });
          } else {
            catalogo.push({
              Id: player.TarifaSelected.TarifaId,
              Orn: data.Departamento,
              Tip: "Reserva",
              Cnt: 1,
              Pco: parseFloat(data.Total.total).toFixed(2),
              Nombre: "Top Tracer " + player.TarifaSelected.Nombre,
              Mnd: "USD",
              ExtraParams: {
                Tarifa: player.TarifaSelected.Tarifa.data,
                TimesData: data.TimesData,
                TTEData: data.TTEData,
              },
              Departamento: data.Departamento,
            });
          }
        } else {*/
        let BeneficioData = null;
        let ExtraTip = null;
        if (player?.invitation?.valid) {
          ExtraTip = "MBS-Beneficio";
          BeneficioData = {
            Miembro: player.invitation.miembro,
            Membresia: player.invitation.membresia,
            Beneficio: player.invitation.beneficio,
            Plan: player.invitation.plan,
            Invitado: true,
          };
        }
        if (player.paseSocio) {
          ExtraTip = "MBS-Beneficio";
          BeneficioData = {
            Miembro: player.paseSocio.Miembro,
            Membresia: player.paseSocio.Membresia,
            Beneficio: player.paseSocio.IDX,
            Plan: player.paseSocio.Plan,
          };
        }
        if (player.estatus != "P") {
          catalogo.push({
            Id: player.TarifaSelected.TarifaId,
            Tip: "Reserva", //data.Addons.roundGolf.Tipo,
            ExtraTip: ExtraTip,
            Orn: data.Departamento,
            Nombre:
              player.TarifaSelected.Nombre +
              "/" +
              player.TarifaSelected.horarioNombre +
              " - " +
              data.Modalidad.nombre,
            Pco: player.Precio
              ? Number(player.Precio)
              : Number(player.TarifaSelected.Precio),
            Cnt: 1,
            Mnd: player.TarifaSelected.Moneda,
            Hdcp: player.hdcp,
            NCarrito: player.nCarrito,
            ExtraParams: {
              TimesData: data.TimesData ? data.TimesData : null,
              TTEData: data.TTEData ? data.TTEData : null,
              BeneficioData: BeneficioData,
              JuegoData: {
                Grp: player.isClient ? player?.dataClient?.tipo : null,
                Phd: player.isClient ? Number(player?.dataClient?.hdcp) : null,
                Can: Number(player.nCarrito),
              },
              TarifaData: {
                Grp: player.isClient ? player?.dataClient?.tipo : null,
                Phd: player.isClient ? Number(player?.dataClient?.hdcp) : null,
                Cod: player?.TarifaSelected?.Iid,
                Can: Number(player.nCarrito),
                Tari: player.TarifaSelected.id,
                //Tur: player?.TarifaSelected?.Turista || false,
                Clr: player?.TarifaSelected?.Color || null,
                Deu: player?.isAdeudo || false,
                Mod: data.Modalidad.id,
                Hor: player?.TarifaSelected?.Horario?.id,
                Pcc: player.TarifaSelected.PrecioCon
                  ? player.TarifaSelected.PrecioCon
                  : 0,
                Pcv: player.TarifaSelected.Precio,
                EC: player.useCupon,
                Sub: player.TarifaSelected.Tarifa?.cateTarifa?.id,
                SubN: player.TarifaSelected.Tarifa?.cateTarifa?.nombre,
                Fam: data.Familia,
                Tem: player?.TarifaSelected?.Tarifa?.data?.Temporada,
                Tar: player?.TarifaSelected?.Tarifa?.data?.Tarifario,
                Seg: player?.TarifaSelected?.Seg || null,
                SegN: player?.TarifaSelected?.SegN || null,
                Mer: player?.TarifaSelected?.Mer || null,
                MerN: player?.TarifaSelected?.MerN || null,
              },
            },
          });
        }
        /*}*/
      }

      //golfClub
      if (player.golfClub) {
        catalogo.push({
          Id: data.Addons.golfClub.id,
          Tip: data.Addons.golfClub.Tipo,
          Nombre: data.Addons.golfClub.Nombre,
          Pco: data.Addons.golfClub.Precio,
          Orn: data.Departamento,
          Cnt: 1,
          Mnd: data.Addons.golfClub.Moneda,
          ExtraParams: {
            GCExtraData: {
              Gender: player.genero,
              Shaft: player.shaft,
              Side: player.side,
            },
          },
        });
      }

      if ((player.estatus == "P") & !player.useRondaCupon) {
        dataRVA.Cuentas[index] = {
          Nombre: player.name,
          Telefono: player.phone,
          Correo: player.email,
          Estatus: player.estatus,
          IdCliente: player.isClient ? player.IdCliente : null,
          Catalogo: [player.accountSnapshot.Catalogo[0].Catalogo[0]],
        };
      } else {

        if (
          player.estatus == "P" &&
          player?.accountSnapshot?.Catalogo[0]?.Catalogo[0]?.FVenta
        ) {
          catalogo[0].FVenta =
            player?.accountSnapshot?.Catalogo[0]?.FVenta;
          catalogo[0].UID =
            player?.accountSnapshot?.Catalogo[0]?.UID;
          catalogo[0].Pagado =
            player?.accountSnapshot?.Catalogo[0]?.Pagado;
          catalogo[0].ExtraParams = { ...player?.accountSnapshot?.Catalogo[0]?.ExtraParams, ...catalogo[0].ExtraParams }

        } else {
          if (player?.accountSnapshot?.Catalogo[0]) {
            if (player?.accountSnapshot?.Catalogo[0].UID) {
              catalogo[0].UID =
                player?.accountSnapshot?.Catalogo[0]?.UID;
            }
            if (player?.accountSnapshot?.Catalogo[0]?.ExtraParams) {
              catalogo[0].ExtraParams = { ...player?.accountSnapshot?.Catalogo[0]?.ExtraParams, ...catalogo[0].ExtraParams }
            }

          }
        }
        if (player?.accountSnapshot?.Catalogo[0] && player.useRondaCupon) {
          if (player?.accountSnapshot?.Catalogo[0]?.Catalogo[0].Tip == "Serie") {
            catalogo[0].Id = player?.accountSnapshot?.Catalogo[0]?.Catalogo[0].Id
            catalogo[0].Nombre = player?.accountSnapshot?.Catalogo[0]?.Catalogo[0].Nombre
            catalogo[0].Pco = player?.accountSnapshot?.Catalogo[0]?.Catalogo[0].Pco
            catalogo[0].Mnd = player?.accountSnapshot?.Catalogo[0]?.Catalogo[0].Mnd
          }

        }

        dataRVA.Cuentas[index] = {
          Nombre: player.name,
          Telefono: player.phone,
          Estatus: player.estatus || "R",
          Correo: player.email,
          IdCliente: player.isClient ? player.IdCliente : null,
          Catalogo: catalogo,
        };
      }
    });
    let Acompañantes = [];
    if (data.CartRiders.length > 0) {
      data.CartRiders.forEach((element) => {
        element.Pco.C = Number(element.Pco.C);
        Acompañantes.push(element);
      });
    }

    dataRVA.Acompañantes = Acompañantes.length != 0 ? Acompañantes : null;
    //Cuenta extraData
    /*let ExtraCatalogo = [];
    if (data.CartRiders.length > 0) {
      let extra_rider = [];
      data.CartRiders.forEach((element) => {
        extra_rider.push(element.name);
      });
      ExtraCatalogo.push({
        Id: data.Addons.cartRider.id,
        Tip: data.Addons.cartRider.Tipo,
        Nombre: data.Addons.cartRider.Nombre,
        Orn: data.Departamento,
        Pco: data.Addons.cartRider.Precio,
        Cnt: data.CartRiders.length,
        Mnd: data.Addons.cartRider.Moneda,
        ExtraParams: {
          ERExtraData: extra_rider.map((EXplayer) => {
            return { N: EXplayer, E: 'R' };
          })
        }
      });
    }

    dataRVA.Cuentas['Extra'] = {
      Catalogo: ExtraCatalogo
    }*/

    return dataRVA;
  }

  static parseAvailabilityData(data, index = 1, salidas = []) {
    try {
      let availability = [];
      salidas.forEach((salida) => {
        let bahia = salida.id;
        let dataObj = [];
        if (data[bahia]) {
          dataObj = Object.entries(data[bahia]);
        }
        dataObj.forEach((element) => {
          let reservationData = [];
          if (element[1].Rvs) {
            let rvsData = Object.entries(element[1].Rvs);
            rvsData.forEach((reserva) => {
              if (reserva[1].Pys) {
                reserva[1].Pys.forEach((player) => {
                  reservationData.push({
                    id: reserva[0],
                    ...player,
                    bahia: bahia,
                    Notas: reserva[1].nots,
                    Color: reserva[1].colr,
                    FolioReserva: reserva[1].frva,
                  });
                });
              } else {
                console.log(element[1]);
              }
            });
            availability.push({
              time: element[0],
              rvsData: reservationData,
              bahia: bahia,
              ...element[1],
            });
          } else {
            availability.push({ time: element[0], bahia: bahia, ...element[1] });
          }
        });
      });
      /*let bahia = index;
      let dataObj = [];
      if (data[bahia]) {
        dataObj = Object.entries(data[bahia]);
      }
      dataObj.forEach((element) => {
        let reservationData = [];
        if (element[1].Rvs) {
          let rvsData = Object.entries(element[1].Rvs);
          rvsData.forEach((reserva) => {
            if (reserva[1].Pys) {
              reserva[1].Pys.forEach((player) => {
                reservationData.push({
                  id: reserva[0],
                  ...player,
                  bahia: bahia,
                  Notas: reserva[1].nots,
                  Color: reserva[1].colr,
                  FolioReserva: reserva[1].frva,
                });
              });
            } else {
              console.log(element[1]);
            }
          });
          availability.push({
            time: element[0],
            rvsData: reservationData,
            ...element[1],
          });
        } else {
          availability.push({ time: element[0], ...element[1] });
        }
      });*/
      return availability;
    } catch (e) {
      console.log(e);
      this.$pgsHelper.catchError(e, { action: "alert" });
    }
  }

  static parseAvailabilityDataTopTracer(data) {
    let availability = [];
    Object.entries(data).forEach(([index, element]) => {
      let bahia = index;
      let reservationData = [];
      let dataReserva = Object.entries(element);
      dataReserva.forEach((reservaInfo) => {
        let horas = reservaInfo[0].split("_");
        if (reservaInfo[1].Rvs) {
          let rvsData = Object.entries(reservaInfo[1].Rvs);
          rvsData.forEach((reserva) => {
            reserva[1].Pys.forEach((player) => {
              reservationData.push({
                id: reserva[0],
                ...player,
                ...reserva[1],
              });
            });
          });

          availability.push({
            bahia: bahia,
            time: horas[0],
            timeEnd: horas[1],
            rvsData: reservationData,
            ...reservaInfo[1],
          });
        } else {
          availability.push({
            bahia: bahia,
            time: horas[0],
            timeEnd: horas[1],
            rvsData: [],
            ...reservaInfo[1],
          });
        }
        reservationData = [];
      });
    });
    return availability;
  }

  static processCatalogo(idx, reserva) {
    const { Catalogo, ...Cuenta } = reserva.Cuentas[idx];
    const newCatalogo = [];
    for (let i = 0; i < Catalogo.length; i++) {
      const item = Catalogo[i];
      // Si es Reserva
      let newItem;
      if (item.Tip === "Reserva" || item.Tip === "Serie") {
        newItem = {
          ...item,
          Id: "Reserva",
          Orn: reserva.Departamento,
          Tip: "RVA-Reserva",
          Cnt: 1,
          Pco: item.ExtraParams?.TarifaData?.Pcn ?? item.Pco,
          Mnd: item.Mnd,
          Nombre: "Reserva",
          Catalogo: [
            {
              ...item,
              Departamento: reserva.Departamento,
              Catalogo: null,
            },
          ],
          ExtraParams: {
            RVAData: {
              I: i,
              Id: reserva.id, //revisar
              Ct: idx,
              Dt: reserva.Departamento
            },
          },
          Departamento: reserva.Departamento,
        };

        // HackTopTracer
        if (reserva.Departamento === "TopTracer") {
          const fecha = moment(reserva.RF.FI, "YYYY-MM-DD_HH:mm");
          let totalMonedero = 0;
          if (item.ExtraParams?.TimesData && item.ExtraParams?.Tarifa) {
            const tarifa = item.ExtraParams.Tarifa;
            const TimesData = item.ExtraParams.TimesData;
            if (["-MR1LMDJB47M20WHGMTU", "WEB"].includes(tarifa.Tarifario)) {
              if (
                ["-MUPhJK0c9Z-SxMj0GtH", "-MR1KqONfmP86AM3t_T1"].some((val) =>
                  tarifa.Subcategoria.includes(val)
                )
              ) {
                // Locales y Socios
                for (const timedata of TimesData) {
                  if (
                    ([0, 2, 3].includes(fecha.day()) ||
                      [4, 5, 6].includes(fecha.day())) &&
                    ["-MR6iztgi5asRdDRsTpY"].includes(timedata.horario)
                  ) {
                    /**
                     * ( Domingo, Martes, Miercoles ) || ( Jueves, Viernes, Sabado )
                     * Horario Tarde
                     * 200MXN X hora, 100MXN X mediaHora
                     */
                    totalMonedero +=
                      timedata.Horas * 200 + timedata.MediasHoras * 100;
                  } else if (
                    [4, 5, 6].includes(fecha.day()) &&
                    ["-MR6j3x20_6l2H7LufyU"].includes(timedata.horario)
                  ) {
                    /**
                     * Jueves, Viernes, Sabado
                     * Horario Noche
                     * 400MXN X hora, 200MXN X mediaHora
                     */
                    totalMonedero +=
                      timedata.Horas * 400 + timedata.MediasHoras * 200;
                  }
                }
              }
            }
          } else if (item.ExtraParams?.TTEData) {
            const TTEData = item.ExtraParams.TTEData;
            for (const TTED of TTEData) {
              if (["-MR1LMDJB47M20WHGMTU", "WEB"].includes(TTED.IdTarifario)) {
                if (
                  ["-MUPhJK0c9Z-SxMj0GtH", "-MR1KqONfmP86AM3t_T1"].includes(
                    TTED.IdSubcategoria
                  )
                ) {
                  // Locales y Socios
                  if (
                    ([0, 2, 3].includes(fecha.day()) ||
                      [4, 5, 6].includes(fecha.day())) &&
                    ["-MR6iztgi5asRdDRsTpY"].includes(TTED.IdHorario)
                  ) {
                    /**
                     * ( Domingo, Martes, Miercoles ) || ( Jueves, Viernes, Sabado )
                     * Horario Tarde
                     * 200MXN X hora, 100MXN X mediaHora
                     */
                    totalMonedero +=
                      TTED.Cantidad *
                      (TTED.IdModalidad === "01HOR"
                        ? 200
                        : TTED.IdModalidad === "30MIN"
                          ? 100
                          : 0);
                  } else if (
                    [4, 5, 6].includes(fecha.day()) &&
                    ["-MR6j3x20_6l2H7LufyU"].includes(TTED.IdHorario)
                  ) {
                    /**
                     * Jueves, Viernes, Sabado
                     * Horario Noche
                     * 400MXN X hora, 200MXN X mediaHora
                     */
                    totalMonedero +=
                      TTED.Cantidad *
                      (TTED.IdModalidad === "01HOR"
                        ? 400
                        : TTED.IdModalidad === "30MIN"
                          ? 200
                          : 0);
                  }
                }
              }
            }
          }

          if (totalMonedero > 0) {
            const prevItem = { ...newItem };
            newItem = {
              Nombre: "Paquete TopTracer",
              Cnt: 1,
              Departamento: reserva.Departamento,
              Id: "PQTTT",
              Orn: Cuenta.IdCliente,
              Catalogo: [
                prevItem,
                {
                  Id: "MonederoFake",
                  Tip: "Servicio",
                  Cnt: 1,
                  Pco: totalMonedero,
                  Nombre: `Monedero AyB ${totalMonedero}`,
                  Catalogo: undefined,
                  Departamento: reserva.Departamento,
                  ExtraParams: null,
                  Mnd: Currencies.getCurrencyDefault(),
                  Orn: Cuenta.IdCliente,
                },
              ],
              ExtraParams: null,
              Mnd: prevItem.Mnd,
              Pco: prevItem.Pco,
              Tip: "Cupon",
            };
          }
        }
      }
      // Si es Addon
      else if (item.Tip === "Addon") {
        const mergeData = {
          Departamento: reserva.Departamento,
          Tip: "RVA-Addon",
          ExtraParams: {
            RVAData: {
              Id: reserva.id,
              Ct: idx,
              I: i,
            },
          },
        };
        if (item.ExtraParams?.ERExtraData) {
          for (let j = 0; j < item.ExtraParams.ERExtraData.length; j++) {
            item.ExtraParams.ERExtraData[j].I = j;
          }
        }
        newItem = merge(item, mergeData);
      }
      // Si es Serie
      /*else if (item.Tip === "Serie") {
        // Modificar Series Clientes
        if (!Cuenta.IdCliente && !item.ExtraParams?.TarifaData?.CCI) {
          throw new Error(
            "Se intento usar una serie sin vincular una cuenta de cliente correctamente"
          );
        }
        newItem = {
          ...item,
          Id: "Reserva",
          Orn: reserva.Departamento,
          Tip: "RVA-Reserva",
          Cnt: 1,
          Pco: item.ExtraParams?.TarifaData?.Pcn ?? item.Pco,
          Mnd: item.Mnd,
          Nombre: "Reserva",
          Catalogo: [
            {
              ...item,
              Departamento: reserva.Departamento,
              Catalogo: null,
            },
          ],
          ExtraParams: {
            RVAData: {
              I: i,
              Id: reserva.id,
              Ct: idx,
            },
          },
          Departamento: reserva.Departamento,
          
        };
      }*/ else {
        newItem = item;
      }
      newCatalogo.push(newItem);
    }
    return newCatalogo;
  }

  static TransformarReserva(reserva) {
    const newReserva = reserva;
    for (const idxCuenta of Object.keys(newReserva.Cuentas)) {
      if (idxCuenta !== "Extra") {
        if (!newReserva.Cuentas[idxCuenta].Estatus) {
          newReserva.Cuentas[idxCuenta].Estatus = "R";
        }
      }
      newReserva.Cuentas[idxCuenta].Catalogo = this.processCatalogo(
        idxCuenta,
        newReserva
      );
      if (
        newReserva.Prepagado &&
        ["Mayorista"].includes(newReserva.Creador.Type) &&
        idxCuenta != "Extra"
      ) {
        newReserva.Cuentas[idxCuenta].Catalogo = [
          {
            Id: "Cupon",
            Orn: newReserva.Creador.Id,
            Tip: "Cupon",
            Cnt: 1,
            Pco: 0,
            Mnd: Currencies.getCurrencyDefault(),
            Nombre: "Cupon Mayorista",
            Catalogo: newReserva.Cuentas[idxCuenta].Catalogo,
            ExtraParams: null,
            Departamento: reserva.Departamento,
          },
        ];
      }
    }
    return newReserva;
  }

  static cleanToCopy(data) {
    data.Creador = data.Creador ? data.Creador.Type : "Admin";
    delete data.FechaCreacion;
    delete data.UpdatedAt;
    delete data.Folio;
    delete data.FolioPago;
    data.Estatus = "Confirmed";
    data.Prepagado = false;

    if (data.Cuentas) {
      for (const idx in data.Cuentas) {
        if (data.Cuentas[idx]) {
          data.Cuentas[idx].Estatus = "R";
          if (Array.isArray(data.Cuentas[idx].Catalogo)) {
            data.Cuentas[idx].Catalogo.forEach(item => {
              delete item.FVenta;
              if (item?.ExtraParams?.RVA) {
                delete item.ExtraParams.RVA;
              }
            });
          }
        }
      }
    }

    return data;
  }
}
